import { useSelector } from 'react-redux'
import { ApplicationState } from 'redux/Stores/types'

import {
  selectDashboard,
  selectDashboardFetchStatus,
  selectDashboards,
  selectDashboardsInGroup,
  selectDashboardsInSameGroup
} from 'redux/selectors/Dashboards'

/**
 * Get all dashboards in a dashboard group (sorted by index)
 * @param dashboardGroupId - Dashboard group ID
 * @returns Array of dashboards sorted by index (empty array if no group ID)
 */
export const useDashboardsInGroup = (dashboardGroupId?: string | null) => {
  return useSelector((state: ApplicationState) =>
    selectDashboardsInGroup(state, dashboardGroupId)
  )
}

/**
 * Get all dashboards in the same group as the given dashboard (sorted by index)
 * @param dashboardId - Dashboard ID
 * @returns Array of dashboards in the same group
 * (empty array if dashboard not found)
 */
export const useDashboardsInSameGroup = (dashboardId: string | null) => {
  return useSelector((state: ApplicationState) =>
    selectDashboardsInSameGroup(state, dashboardId)
  )
}

/**
 * Get dashboard by ID.
 * @param dashboardId - Dashboard ID
 * @returns TDashboard | null
 */
export const useDashboard = (dashboardId: string | null) => {
  return useSelector((state: ApplicationState) =>
    selectDashboard(state, dashboardId)
  )
}

/**
 * Get all dashboards.
 * @returns Array of all dashboards
 */
export const useDashboards = () => {
  return useSelector(selectDashboards)
}

/**
 * Get fetch status for a specific dashboard.
 * @param dashboardId - Dashboard ID
 * @returns Fetch status entry with status and optional errorStatusCode
 */
export const useDashboardFetchStatus = (dashboardId: string | null) => {
  return useSelector((state: ApplicationState) =>
    selectDashboardFetchStatus(state, dashboardId)
  )
}
